import React from 'react';
//MUI
import CircularProgress, {CircularProgressProps} from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import {makeStyles} from 'tss-react/mui';
//DS
import DialogBase from '../../atomicos/DialogBase';
import {DialogProps} from '@mui/material';

const useStyles = makeStyles()((theme) => ({
   progress: {
      margin: '16px'
   },
   root: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      paddingLeft: '16px',
      paddingRight: '16px'
   }
}));
interface DialogBaseProps extends DialogProps {
   disableBackdropClick?: boolean;
   disableEscapeKeyDown?: boolean;
   containerId?: string;
}
export interface LoadingModalProps extends DialogBaseProps {
   mensaje?: string;
   circularProgressProps?: CircularProgressProps;
   children?: React.ReactNode;
}
const LoadingModal: React.FC<LoadingModalProps> = ({
   mensaje,
   children,
   circularProgressProps,
   ...otros
}) => {
   const {classes} = useStyles();
   const finalMsg =
      children && typeof children === 'string' ? children : mensaje || 'Por favor espere.';
   return (
      <DialogBase
         {...otros}
         disableBackdropClick
         disableEscapeKeyDown
      >
         <div className={classes.root}>
            <CircularProgress
               className={classes.progress}
               {...circularProgressProps}
            />
            <Typography
               variant="subtitle1"
               align="center"
               color="textSecondary"
               component="p"
            >
               Cargando...
            </Typography>
            <Typography
               variant="subtitle1"
               align="center"
               color="textSecondary"
               component="p"
            >
               {finalMsg}
            </Typography>
         </div>
      </DialogBase>
   );
};

export default LoadingModal;
